<div class="flex flex-row justify-between items-center">
  <div class="flex flex-col justify-start items-start space-x-4 w-full">
    <h1 [attr.data-cy]="testIds.JOB_NAME">{{ jobName }}</h1>
    <div
      class="flex flex-row justify-start items-center space-x-4 w-full font-xs"
    >
      <button mat-icon-button (click)="edit()">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button (click)="print(true)">
        <mat-icon>download</mat-icon>
      </button>
      <button mat-icon-button (click)="print(false)">
        <mat-icon>print</mat-icon>
      </button>
    </div>
  </div>
  <button
    mat-stroked-button
    class="flex-shrink-0"
    (click)="openHistoryDialog()"
    [attr.data-cy]="testIds.VIEW_ITEM_HISTORY"
  >
    View Item
  </button>
</div>
<div class="flex flex-row items-center justify-start">
  <app-key-value-pair
    class="flex-1"
    name="Job ID"
    [attr.data-cy]="testIds.JOB_ID"
    [value]="job.id.toString()"
  ></app-key-value-pair>
</div>
<app-key-value-pair
  name="Serial Number"
  *ngIf="job.repairable_type === 'customerEquipment'"
  [key]="testIds.EQUIPMENT_SERIAL_NUMBER"
  [value]="serialNumber"
></app-key-value-pair>
<app-key-value-pair
  name="Status"
  [key]="testIds.JOB_STATUS"
  [value]="job.work_status | workshopJobStatusLabel"
></app-key-value-pair>
<app-key-value-pair
  *ngIf="job.details"
  [key]="testIds.JOB_DETAILS"
  name="Defect details"
  [value]="job.details"
></app-key-value-pair>
<app-key-value-pair
  *ngIf="job.notes"
  name="Notes"
  [key]="testIds.JOB_NOTES"
  [value]="job.notes"
></app-key-value-pair>
<div class="flex flex-row justify-start items-center gap-x-4">
  <a
    *ngIf="repairDocket"
    [routerLink]="['/repair-docket', job.repair_docket_id]"
    [attr.data-cy]="testIds.DOCKET_LINK"
  >
    <ng-container *ngIf="repairDocket.finalized_at === null; else invoice">
      Repair docket {{ job.repair_docket_id }}
    </ng-container>
    <ng-template #invoice>
      Repair Invoice {{ job.repair_docket_id }}
    </ng-template>
  </a>

  @if (job.template_id) {
    <span class="text-sm">Created from template: {{ templateName }}</span>
  }
</div>
<iframe [style.display]="'none'" frameborder="0" #printFrame></iframe>
